import React, { Component } from 'react';
import PropTypes from 'prop-types'; /* eslint-disable-line no-unused-vars */

import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Switch from '@material-ui/core/Switch';

import { asField } from 'informed';
import { get } from 'lodash-es';

import HtmlTooltip from './HtmlTooltip';
import './SwitchFieldMU.scss';

class SwitchFieldMUComponent extends Component {
  constructor(props) {
    super(props);
    this.selectRef = React.createRef();
  }

  // workaround to prevent an issue of react-number-format with decimalSeparator: ','
  handleChange = e => {
    // eslint-disable-next-line react/prop-types
    const { fieldApi, onChange } = this.props;
    if (fieldApi.setValue) fieldApi.setValue(e.target.checked);
    if (onChange) {
      onChange(e.target.checked);
    }
  };

  render() {
    // eslint-disable-next-line react/prop-types
    const { fieldApi, fieldState, ...props } = this.props;
    const value = get(fieldState, 'value');
    const setTouched = get(fieldApi, 'setTouched');
    const {
      // classes,
      // onChange,
      onBlur,
      field,
      // defaultValue = false,
      // multiple,
      // shrink,
      label = '',
      //   name = "default_name",
      // helperText = '',
      // ...rest
      disabled,
      labelPlacement,
      tooltip,
    } = props;
    return (
      <>
        {tooltip && (
          <HtmlTooltip title={tooltip}>
            <span className="helper">?</span>
          </HtmlTooltip>
        )}
        <FormGroup row className="coog-switch">
          <FormControlLabel
            className="label-switch"
            control={
              <Switch
                ref={this.selectRef}
                className={`switch-form-group`}
                name={field}
                checked={!!value}
                onChange={this.handleChange}
                onBlur={e => {
                  setTouched();
                  if (onBlur) {
                    onBlur(e);
                  }
                }}
                color="primary"
                value={!!value}
                disabled={disabled}
              />
            }
            label={label}
            labelPlacement={labelPlacement}
          />
        </FormGroup>
      </>
    );
  }
}

SwitchFieldMUComponent.propTypes = {
  label: PropTypes.string,
  labelPlacement: PropTypes.string,
  fieldApi: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  tooltip: PropTypes.string,
};

SwitchFieldMUComponent.defaultProps = {
  label: '',
  labelPlacement: 'top',
};

export default asField(SwitchFieldMUComponent);
